import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NgxsModule} from '@ngxs/store';
import {PlayerState} from './player.state';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forRoot([PlayerState]),
  ],
  declarations: [],
})
export class RootStoreModule {
}
